/**
 * Imports only components, but no theme
 *
 */

import './themes/ui/ui-theme-components.scss'
